import { normalizeHaklaiExpensesForDependencies } from "../calc/expenses/logic/haklaiExpensesHelpers";
import { sanitizePre1997ConstructionFlags } from "../calc/shared/haklaiRawPayloadHelpers";
import { CATEGORIES, HAKLAI_PTOR_TYPES } from "../calc/shared/haklaiConstants";
import { normalizeHaklaiPropertyPartPtorSelections } from "../calc/shared/haklaiPtorHelpers";
import { applyHaklaiPrisaDependencies } from "./haklaiPrisaDependencies";

const clearHaklaiPropertyPartPtorSelections = (propertyPartsData = {}) => {
  let changed = false;
  const nextPropertyPartsData = Object.entries(propertyPartsData || {}).reduce((acc, [partKey, part]) => {
    if (
      part?.category === CATEGORIES.RESIDENTIAL
      && part.ptorType
      && part.ptorType !== HAKLAI_PTOR_TYPES.NONE
    ) {
      changed = true;
      acc[partKey] = { ...part, ptorType: HAKLAI_PTOR_TYPES.NONE };
      return acc;
    }

    acc[partKey] = part;
    return acc;
  }, {});

  return {
    changed,
    propertyPartsData: changed ? nextPropertyPartsData : propertyPartsData
  };
};

export const applyHaklaiPreCalcDependencyRules = (calcState, fieldName, value) => {
  const updated = {
    ...calcState,
    preCalc: { ...calcState.preCalc, [fieldName]: value }
  };

  if (fieldName === "soldPropertyDate") {
    updated.preCalc.hasTzinunOnPtor = false;
  }

  if (fieldName === "wayOfGettingProperty") {
    const enteredGiftFlow = (
      value === "gift"
      && calcState.preCalc?.wayOfGettingProperty !== "gift"
    );

    if (enteredGiftFlow) {
      const ptorState = clearHaklaiPropertyPartPtorSelections(
        updated.mainCalc?.propertyPartsData || {}
      );
      updated.preCalc.ptorType = HAKLAI_PTOR_TYPES.NONE;
      updated.preCalc.hasTzinunOnPtor = false;
      if (ptorState.changed) {
        updated.mainCalc = {
          ...(updated.mainCalc || calcState.mainCalc),
          propertyPartsData: ptorState.propertyPartsData
        };
      }
    } else {
      const ptorState = normalizeHaklaiPropertyPartPtorSelections(
        updated.mainCalc?.propertyPartsData || {},
        updated.preCalc || {}
      );
      updated.preCalc.ptorType = ptorState.selectedPtorType;
      if (
        ptorState.changed
        || ptorState.selectedPtorType !== HAKLAI_PTOR_TYPES.SINGLE
        || updated.preCalc.wayOfGettingProperty !== "gift"
      ) {
        updated.preCalc.hasTzinunOnPtor = false;
      }
      if (ptorState.changed) {
        updated.mainCalc = {
          ...(updated.mainCalc || calcState.mainCalc),
          propertyPartsData: ptorState.propertyPartsData
        };
      }
    }
  }

  if (fieldName === "hasZaban" || fieldName === "wayOfGettingProperty" || fieldName === "totalPropertyCost") {
    const normalizedExpensesState = normalizeHaklaiExpensesForDependencies(
      updated.mainCalc?.expenses || [],
      updated.mainCalc?.propertyPartsData || {},
      updated.preCalc?.hasZaban === true,
      updated.preCalc?.totalPropertyCost
    );

    if (normalizedExpensesState.changed) {
      updated.mainCalc = {
        ...(updated.mainCalc || calcState.mainCalc),
        expenses: normalizedExpensesState.expenses
      };
    }
  }

  const sanitizedPre1997State = sanitizePre1997ConstructionFlags(
    updated.mainCalc?.propertyPartsData || {},
    updated.preCalc
  );
  if (sanitizedPre1997State.changed) {
    updated.mainCalc = {
      ...(updated.mainCalc || calcState.mainCalc),
      propertyPartsData: sanitizedPre1997State.propertyPartsData
    };
  }

  if (fieldName === "soldPropertyDate" || fieldName === "wayOfGettingProperty") {
    return applyHaklaiPrisaDependencies(updated);
  }

  return updated;
};
